import RegistrationSetupGallery from './RegistrationSetupGallery';

export default RegistrationSetupGallery;
